export const getters = {
    list: state => state.list,
    limit: state => state.limit,
   
};